/**
 * Незавершённый вход через бота, переживающий перезагрузку вкладки.
 *
 * Переключение приложений на телефоне усыпляет вкладку, а иногда браузер её и
 * вовсе выгружает: вернувшийся человек получил бы заново открытую страницу,
 * которой не с чем идти к серверу. Хранилище вкладки закрывается вместе с ней,
 * а заявка живёт минуты — дольше кода здесь ничего не лежит.
 *
 * Знать о незавершённом входе нужно не только самой форме входа: пока он идёт,
 * учётная запись вот-вот сменится, и остальному приложению нельзя делать
 * выводы из ответов сервера на старый токен.
 */

const STORAGE_KEY = 'anon-chat.web-login';

export interface WebLoginTicket {
  code: string;
  url: string;
  /** Момент, после которого заявка бесполезна. */
  expiresAt: number;
}

/** Приватный режим запрещает хранилище: вход от этого ломаться не должен. */
export function rememberTicket(ticket: WebLoginTicket | null): void {
  try {
    if (ticket === null) {
      sessionStorage.removeItem(STORAGE_KEY);
    } else {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ticket));
    }
  } catch {
    // Незавершённый вход просто не переживёт перезагрузку.
  }
}

/**
 * Заявка, которую стоит продолжить ждать.
 *
 * Просроченную забываем молча: иначе человек, однажды не доведший вход до
 * конца, получал бы «ссылка устарела» на каждой следующей открытой странице.
 */
export function rememberedTicket(): WebLoginTicket | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const ticket = JSON.parse(raw) as WebLoginTicket;
    if (ticket.expiresAt <= Date.now()) {
      rememberTicket(null);
      return null;
    }
    return ticket;
  } catch {
    return null;
  }
}

/** Идёт ли вход прямо сейчас. */
export function webLoginPending(): boolean {
  return rememberedTicket() !== null;
}
